import { ErrorBoundary as _ErrorBoundary } from 'react-error-boundary';
// @ts-ignore
export type { ErrorBoundaryProps } from 'react-error-boundary/dist/declarations/src/types';

export const ErrorBoundary = _ErrorBoundary;
